// Static data + API config for Timeless Auto Imports
import axios from 'axios';

export const COMPANY = {
  name: 'Timeless Auto Imports Limited',
  shortName: 'Timeless',
  motto: "Don't Just Dream it, Drive it.",
  tagline: 'Your Complete Automotive Solution',
  phone: '876-622-0900',
  phone2: '876-403-8436',
  whatsapp: '18764038436',
  email: 'timelessautoimportslimited@gmail.com',
  address: 'Lot 36, Bustamante Highway, Four Path, Clarendon',
  hours: 'Mon–Sat: 9:00 AM – 5:00 PM',
  instagram: '@timeless.auto.imports',
  social: {
    instagram: 'https://instagram.com/timeless.auto.imports',
    facebook: 'https://facebook.com',
    youtube: 'https://youtube.com'
  }
};

export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_luxury-imports-3/artifacts/8azizvqn_WhatsApp%20Image%202026-06-19%20at%204.00.36%20PM.jpeg';
export const HERO_BG_URL = 'https://customer-assets.emergentagent.com/job_luxury-imports-3/artifacts/7j4ycb7n_WhatsApp%20Image%202026-06-19%20at%204.00.36%20PM%20%281%29.jpeg';
export const FLYER_URL = 'https://customer-assets.emergentagent.com/job_luxury-imports-3/artifacts/6gg74ndu_WhatsApp%20Image%202026-06-19%20at%204.00.36%20PM%20%282%29.jpeg';

export const HERO_IMAGE = HERO_BG_URL;
export const SHOWROOM_IMAGES = [
  HERO_BG_URL,
  'https://images.unsplash.com/photo-1692406069831-0bb7ea297645?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxjYXIlMjBzaG93cm9vbXxlbnwwfHx8fDE3ODE5MDA1Nzl8MA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1644749700856-a82a92828a1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxjYXIlMjBzaG93cm9vbXxlbnwwfHx8fDE3ODE5MDA1Nzl8MA&ixlib=rb-4.1.0&q=85',
  'https://images.pexels.com/photos/16176576/pexels-photo-16176576.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
];
export const TEAM_IMAGES = [
  'https://images.pexels.com/photos/7144183/pexels-photo-7144183.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  'https://images.pexels.com/photos/7144225/pexels-photo-7144225.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
];

export const TESTIMONIALS = [
  { id: 1, name: 'Andre Bennett', role: 'Kingston, JA', text: 'Bought my car from Timeless and the experience was first class — transparent pricing, immaculate condition, and they handled everything.', rating: 5, initials: 'AB' },
  { id: 2, name: 'Shanique Walker', role: 'Mandeville, JA', text: 'Their hybrid mechanics fixed my battery cells nobody else could. Saved me a fortune. 10/10.', rating: 5, initials: 'SW' },
  { id: 3, name: "Marcus O'Connor", role: 'May Pen, JA', text: 'Best dealer in Clarendon. Fair prices, top quality units, and after-sale support that actually delivers.', rating: 5, initials: 'MO' },
  { id: 4, name: 'Tasha Bailey', role: 'Portmore, JA', text: 'Body work after my fender bender looked brand new. Plus they sourced a hard-to-find part for me. One-stop shop!', rating: 5, initials: 'TB' }
];

export const STATS = [
  { value: '500+', label: 'Vehicles Sold' },
  { value: '6+', label: 'Service Types' },
  { value: '100%', label: 'Verified Imports' },
  { value: '4.9★', label: 'Customer Rating' }
];

export const FEATURES = [
  { title: 'Hand-Picked Imports', desc: 'Every vehicle is personally inspected at the source auction. No surprises, ever.', icon: 'BadgeCheck' },
  { title: 'Transparent Pricing', desc: 'No hidden fees. The price you see is the price you pay, all in.', icon: 'Tag' },
  { title: 'Hybrid Specialists', desc: 'Trained mechanics for hybrid diagnostics, repairs, and battery cell replacement.', icon: 'Zap' },
  { title: 'Full After-Sale Care', desc: 'Servicing, body work, accessories, and genuine parts — all in one location.', icon: 'Wrench' },
  { title: 'Island-Wide Delivery', desc: 'We deliver your new vehicle to your doorstep — anywhere in Jamaica.', icon: 'Truck' },
  { title: 'Verified History', desc: 'Full Japanese auction sheets and odometer verification on every unit.', icon: 'FileCheck' }
];

export const MAKES = ['BMW', 'Daihatsu', 'Honda', 'Mazda', 'Mercedes', 'Nissan', 'Subaru', 'Suzuki', 'Toyota'];
export const BODY_STYLES = ['Hatchback', 'SUV', 'Sedan', 'Station Wagon', 'MPV', 'Coupe', 'Pickup', 'Van', 'N/A'];
export const TRANSMISSIONS = ['Automatic', 'CVT', 'Manual', 'DCT', 'N/A'];
export const FUELS = ['Petrol', 'Hybrid', 'Diesel', 'Electric', 'N/A'];
export const DRIVES = ['FWD', 'RWD', 'AWD', '4WD', 'N/A'];
export const YEARS = Array.from({ length: 12 }, (_, i) => new Date().getFullYear() - i);

export const PART_CATEGORIES = [
  'Service Parts',
  'Engine Parts',
  'Suspension & Brakes',
  'Hybrid Components',
  'Body Parts',
  'Electrical',
  'Tires & Rims',
  'Interior',
  'Vehicle Accessories',
  'Other'
];

export const FUEL_TYPES = [
  { value: 'petrol', label: 'Petrol' },
  { value: 'hybrid', label: 'Petrol Hybrid' },
  { value: 'diesel', label: 'Diesel' },
  { value: 'electric', label: 'Electric' },
];

export const BANKING = {
  account_name: 'Timeless Auto Imports',
  bank: 'Sagicor Bank Jamaica Limited',
  bank_address: '5B Manchester Avenue',
  swift_code: 'SAJAJMKN',
  account_number: '5503975515',
  account_type: 'JMD (Jamaican) Chequing',
  branch: 'May Pen'
};

export const DELIVERY = {
  free_zones: ['Clarendon', 'Manchester (Mandeville)'],
  island_wide: 'Island-wide delivery through Knutsford Express',
  member_perks: 'Members get free delivery islandwide — we cover Knutsford too.',
};

export const formatPrice = (n) => `J$${Number(n || 0).toLocaleString('en-US')}`;

// ---- API client
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const apiClient = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 90000,
  // CSRF defense: a custom header can only be set by our own first-party JS.
  // Cross-site attackers can't add it on a "simple" request, and adding it on a
  // fetch forces a CORS preflight that our locked allowlist rejects.
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
});

export const VehicleAPI = {
  list: (params) => apiClient.get('/vehicles', { params }).then(r => r.data),
  get: (id) => apiClient.get(`/vehicles/${id}`).then(r => r.data),
  create: (payload) => apiClient.post('/vehicles', payload).then(r => r.data),
  update: (id, payload) => apiClient.put(`/vehicles/${id}`, payload).then(r => r.data),
  remove: (id) => apiClient.delete(`/vehicles/${id}`).then(r => r.data),
};

export const LeadAPI = {
  create: (payload) => apiClient.post('/leads', payload).then(r => r.data),
  list: () => apiClient.get('/leads').then(r => r.data),
};

export const PartAPI = {
  list: (params) => apiClient.get('/parts', { params }).then(r => r.data),
  get: (id) => apiClient.get(`/parts/${id}`).then(r => r.data),
  create: (payload) => apiClient.post('/parts', payload).then(r => r.data),
  update: (id, payload) => apiClient.put(`/parts/${id}`, payload).then(r => r.data),
  remove: (id) => apiClient.delete(`/parts/${id}`).then(r => r.data),
  categories: () => apiClient.get('/parts/categories').then(r => r.data),
  sync: () => apiClient.post('/parts/sync').then(r => r.data),
  autoCategorize: () => apiClient.post('/parts/auto-categorize').then(r => r.data),
  byVehicle: (vehicleId, params) => apiClient.get(`/vehicles/${vehicleId}/parts`, { params }).then(r => r.data),
  smartSearch: (q, limit = 24) => apiClient.get('/parts/search', { params: { q, limit } }).then(r => r.data),
};

export const MarketingAPI = {
  generate: (body) => apiClient.post('/admin/marketing/generate', body).then(r => r.data),
  drafts: (params = {}) => apiClient.get('/admin/marketing/drafts', { params }).then(r => r.data),
  update: (id, patch) => apiClient.patch(`/admin/marketing/drafts/${id}`, patch).then(r => r.data),
  approve: (id) => apiClient.post(`/admin/marketing/drafts/${id}/approve`).then(r => r.data),
  publish: (id) => apiClient.post(`/admin/marketing/drafts/${id}/publish`).then(r => r.data),
  remove: (id) => apiClient.delete(`/admin/marketing/drafts/${id}`).then(r => r.data),
};

export const BlogAPI = {
  list: () => apiClient.get('/blog').then(r => r.data),
  get: (slug) => apiClient.get(`/blog/${slug}`).then(r => r.data),
};

export const OrderAPI = {
  list: (params) => apiClient.get('/orders', { params }).then(r => r.data),
  get: (id) => apiClient.get(`/orders/${id}`).then(r => r.data),
  update: (id, payload) => apiClient.patch(`/orders/${id}`, payload).then(r => r.data),
  track: (order_number, email) => apiClient.post('/orders/track', { order_number, email }).then(r => r.data),
  paypalCreate: (payload) => apiClient.post('/orders/paypal/create', payload).then(r => r.data),
  paypalCapture: (paypalOrderId) => apiClient.post(`/orders/paypal/capture/${paypalOrderId}`).then(r => r.data),
  paypalGet: (paypalOrderId) => apiClient.get(`/orders/paypal/${paypalOrderId}`).then(r => r.data),
  resendEmails: (id) => apiClient.post(`/orders/${id}/resend-emails`).then(r => r.data),
  resolveRefund: (id, action, admin_note) => apiClient.post(`/orders/${id}/refund/resolve`, { action, admin_note }).then(r => r.data),
};

export const PromoAPI = {
  active: () => apiClient.get('/promos/active').then(r => r.data),
};

export const MeAPI = {
  orders: () => apiClient.get('/me/orders').then(r => r.data),
  watchlist: () => apiClient.get('/me/watchlist').then(r => r.data),
  watchIds: () => apiClient.get('/me/watchlist/ids').then(r => r.data),
  watch: (item_type, item_id) => apiClient.post('/me/watchlist', { item_type, item_id }).then(r => r.data),
  unwatch: (item_type, item_id) => apiClient.delete(`/me/watchlist/${item_type}/${item_id}`).then(r => r.data),
  profile: () => apiClient.get('/me/profile').then(r => r.data),
  updateProfile: (payload) => apiClient.put('/me/profile', payload).then(r => r.data),
  cancelOrder: (id, reason) => apiClient.post(`/me/orders/${id}/cancel`, { reason }).then(r => r.data),
  returnOrder: (id, reason) => apiClient.post(`/me/orders/${id}/return`, { reason }).then(r => r.data),
  garage: () => apiClient.get('/me/garage').then(r => r.data),
  garageAdd: (payload) => apiClient.post('/me/garage', payload).then(r => r.data),
  garageUpdate: (id, payload) => apiClient.patch(`/me/garage/${id}`, payload).then(r => r.data),
  garageRemove: (id) => apiClient.delete(`/me/garage/${id}`).then(r => r.data),
};

export const GarageAPI = {
  makesModels: () => apiClient.get('/vehicles/makes-models').then(r => r.data),
  partsThatFit: ({ make, model, year, vehicle_id, fuel_type, category, limit }) =>
    apiClient.get('/parts/fit', { params: { make, model, year, vehicle_id, fuel_type, category, limit } }).then(r => r.data),
};

export const CustomersAPI = {
  list: () => apiClient.get('/admin/customers').then(r => r.data),
  grantMembership: (userId, body) => apiClient.post(`/admin/users/${userId}/membership`, body).then(r => r.data),
  cancelMembership: (userId) => apiClient.delete(`/admin/users/${userId}/membership`).then(r => r.data),
  membershipHistory: (userId) => apiClient.get(`/admin/users/${userId}/membership/history`).then(r => r.data),
};

// Currency helper for the checkout UI
export const CURRENCIES = [
  { code: 'usd', symbol: 'US$', label: 'US Dollar (USD)' },
  { code: 'jmd', symbol: 'J$', label: 'Jamaican Dollar (JMD)' },
];
export const formatCurrency = (amount, code) => {
  const c = (code || 'usd').toLowerCase();
  const sym = c === 'jmd' ? 'J$' : 'US$';
  return `${sym}${Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

// SEO-friendly alt text so search engines get keyword-rich context on every image.
export const altForVehicle = (v, idx = 0) => {
  if (!v) return 'Vehicle at Timeless Auto Imports Jamaica';
  const base = [v.year, v.color, v.make, v.model].filter(Boolean).join(' ');
  const body = v.body && v.body !== 'N/A' ? ` ${v.body.toLowerCase()}` : '';
  const suffix = idx > 0 ? ` — photo ${idx + 1}` : '';
  return `${base}${body} for sale at Timeless Auto Imports Jamaica${suffix}`.trim();
};
export const altForPart = (p, idx = 0) => {
  if (!p) return 'Auto part at Timeless Auto Imports Jamaica';
  const bits = [p.brand, p.name].filter(Boolean).join(' ');
  const cat = p.category ? ` (${p.category})` : '';
  const fits = p.fits ? ` — fits ${p.fits}` : '';
  const suffix = idx > 0 ? ` — photo ${idx + 1}` : '';
  return `${bits}${cat}${fits} at Timeless Auto Imports Jamaica${suffix}`.trim();
};

export const NoticeAPI = {
  list: (params) => apiClient.get('/notices', { params }).then(r => r.data),
  get: (id) => apiClient.get(`/notices/${id}`).then(r => r.data),
  create: (payload) => apiClient.post('/notices', payload).then(r => r.data),
  update: (id, payload) => apiClient.put(`/notices/${id}`, payload).then(r => r.data),
  remove: (id) => apiClient.delete(`/notices/${id}`).then(r => r.data),
};

export const ContentAPI = {
  get: (key) => apiClient.get(`/content/${key}`).then(r => r.data),
  put: (key, value) => apiClient.put(`/content/${key}`, { value }).then(r => r.data),
};

export const SettingsAPI = {
  publicSettings: () => apiClient.get('/settings/public').then(r => r.data),
  get: () => apiClient.get('/settings').then(r => r.data),
  update: (payload) => apiClient.put('/settings', payload).then(r => r.data),
};

export const SaleAPI = {
  list: () => apiClient.get('/sales').then(r => r.data),
  create: (payload) => apiClient.post('/sales', payload).then(r => r.data),
  remove: (id) => apiClient.delete(`/sales/${id}`).then(r => r.data),
};

export const AnalyticsAPI = {
  get: () => apiClient.get('/analytics').then(r => r.data),
  visitors: () => apiClient.get('/analytics/visitors').then(r => r.data),
  live: () => apiClient.get('/analytics/live').then(r => r.data),
};

export const VEHICLE_STATUS = [
  { v: 'available', label: 'Available' },
  { v: 'on_sale', label: 'On Sale' },
  { v: 'featured', label: 'Featured' },
  { v: 'new_arrival', label: 'New Arrival' },
  { v: 'locally_driven', label: 'Locally Driven' },
  { v: 'reserved', label: 'Reserved' },
  { v: 'coming_soon', label: 'Coming Soon' },
  { v: 'sold', label: 'Sold' }
];

export const PART_STATUS = [
  { v: 'available', label: 'Available' },
  { v: 'on_sale', label: 'On Sale' },
  { v: 'featured', label: 'Featured' },
  { v: 'new_arrival', label: 'New Arrival' },
  { v: 'reserved', label: 'Reserved' },
  { v: 'coming_soon', label: 'Coming Soon' },
  { v: 'sold', label: 'Sold Out' }
];

// Map status -> badge color classes (Tailwind)
export const STATUS_BADGE = {
  available:     { cls: 'bg-green-600 text-white',   label: 'Available' },
  on_sale:       { cls: 'bg-red-600 text-white',     label: 'On Sale' },
  featured:      { cls: 'bg-[#e11d2c] text-white',   label: 'Featured' },
  new_arrival:   { cls: 'bg-blue-600 text-white',    label: 'New Arrival' },
  locally_driven:{ cls: 'bg-teal-600 text-white',    label: 'Locally Driven' },
  reserved:      { cls: 'bg-amber-500 text-black',   label: 'Reserved' },
  coming_soon:   { cls: 'bg-purple-600 text-white',  label: 'Coming Soon' },
  sold:          { cls: 'bg-black text-white',       label: 'Sold' },
  // legacy compat
  under_offer:   { cls: 'bg-amber-500 text-black',   label: 'Reserved' }
};

export const DEFAULT_ABOUT = {
  hero_title: 'A used-car experience that actually feels new.',
  hero_subtitle: "Timeless Auto Imports was born from a simple idea: buying pre-owned shouldn\u2019t feel like a gamble. So we built a dealership where transparency is the default and quality is non-negotiable.",
  est_year: '2013',
  hero_image: '',
  story_image: '',
  story_title: 'Twelve years of doing things the right way.',
  story_paragraphs: [
    "What began in 2013 as a one-bay garage in May Pen has grown into Clarendon\u2019s most-trusted source for pre-owned imports. From day one, our promise was simple: never sell a car we wouldn\u2019t put our own families in.",
    "Today, our team works directly with auction partners in Yokohama and Nagoya. We hand-pick each vehicle in person, ship it home, and put it through a thorough pre-delivery inspection before it ever lands a buyer.",
    "The result? A name our customers trust to bring them their next \u2014 and the one after that."
  ],
  stats: [
    { value: '500+', label: 'Vehicles Sold' },
    { value: '12+', label: 'Years in Business' },
    { value: '100%', label: 'Verified Imports' },
    { value: '4.9\u2605', label: 'Customer Rating' }
  ],
  values: [
    { title: 'Integrity first', desc: 'We disclose everything \u2014 auction sheets, history, blemishes. No surprises.' },
    { title: 'Curated excellence', desc: 'Less inventory, more quality. Every car earns its place in our showroom.' },
    { title: 'Customer for life', desc: 'From first browse to your fifth service \u2014 we\u2019re your auto partner.' },
    { title: 'Direct from source', desc: 'Long-standing relationships with Japan\u2019s top auction houses.' }
  ]
};

export const AuthAPI = {
  exchange: (sessionId) => apiClient.post('/auth/session', null, { headers: { 'X-Session-ID': sessionId } }).then(r => r.data),
  me: () => apiClient.get('/auth/me').then(r => r.data),
  logout: () => apiClient.post('/auth/logout').then(r => r.data),
};
